import React from 'react'
import { Icon } from '@chakra-ui/react'

export function IconDotsHorizontal(rest) {
  return (
    <Icon viewBox="0 0 20 20" {...rest}>
      <path
        fill="currentColor"
        fillRule="evenodd"
        clipRule="evenodd"
        d="M6 10a2 2 0 11-4 0 2 2 0 014 0zM12 10a2 2 0 11-4 0 2 2 0 014 0zM16 12a2 2 0 100-4 2 2 0 000 4z"
      />
    </Icon>
  )
}
